import { toColor } from "@playlive/overlay-core/colors";
import { MinProgressBar } from "@playlive/overlay-core/progress-bars/min";
import { deepSignal } from "deepsignal";
import CustomizeSection from "@/components/overlays/shared/customize-section.jsx";
import LinkSetup from "@/components/overlays/social/link-setup/link-setup.jsx";
import HorizontalCustomizeWrapper from "@/components/overlays/wrapper/horizonal-customize-wrapper.jsx";
import ScaledOverlayWrapper from "@/components/overlays/wrapper/scaled-overlay-wrapper.jsx";
import ColorPicker from "@/components/pickers/color-picker/color.picker.jsx";
import ColorPickerLabel from "@/components/pickers/color-picker/color-picker-label.jsx";
import CharitySection from "@/components/shared/charity-section.jsx";
import useCommon from "@/hooks/useCommon.js";
import useDemoProgressBarData from "@/hooks/useDemoProgressBarData.js";
import { isYes } from "@/util/common.js";
import { CHARITY } from "@/util/const.js";

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  bgColor: "default-red",
  ccamMode: "no",
});

const useBetaProgressBars = isYes(import.meta.env.VITE_BETA_PROGRESS_BARS || "no");
const urlBase = useBetaProgressBars ? "progress-bars/min" : "min";

export default function MinProgressBarPage() {
  const { setConfigState, overlayURL, overlayInfo } = useCommon({
    config,
    urlBase,
  });

  const { demoMilestones } = useDemoProgressBarData(config);

  function filterColors(color) {
    return !color.includes("grey") && !color.includes("black");
  }

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col xl:flex-row overflow-x-hidden">
        <div className="example_overlay select-none w-full">
          <ScaledOverlayWrapper allowScaling={false} innerClassName="h-[250px]">
            <MinProgressBar
              className="shadow-2xl"
              milestones={demoMilestones}
              goalAmount={1000}
              backgroundColor={isYes(config.ccamMode) ? "light-yellow" : toColor(config.bgColor)}
              currentAmount={750}
              originalGoalAmount={0}
              showOriginalGoal={false}
              ccamMode={isYes(config.ccamMode) ?? false}
            />
          </ScaledOverlayWrapper>
        </div>

        <HorizontalCustomizeWrapper className="flex flex-col mb-0!">
          <CharitySection onChange={setConfigState} charityType={config.charityType} />

          <CustomizeSection title="Appearance" className="flex-grow">
            <ColorPickerLabel
              color={config.bgColor}
              labelText="Progress bar"
              className={
                isYes(config.ccamMode)
                  ? "opacity-50 transition-opacity"
                  : "opacity-100 transition-opacity"
              }
            />

            <ColorPicker
              disabled={isYes(config.ccamMode)}
              filterFunction={filterColors}
              currentColor={config.bgColor}
              fieldName="bgColor"
              onChange={setConfigState}
            />

            {/* <YesNoButtonInput
              className="flex-1"
              onChange={setConfigState}
              mode="checkbox"
              currentValue={config.ccamMode}
              name="ccamMode"
              label="CCAM Mode"
              labelNoClass="text-black"
              buttonNoClass="bg-warning opacity-60 shadow-none"
              buttonYesClass="bg-warning opacity-100 shadow-none"
              labelYesClass="text-black"
            /> */}
          </CustomizeSection>
        </HorizontalCustomizeWrapper>
      </div>

      <LinkSetup
        constrainWidth={false}
        charityType={config.charityType}
        obsDimensions={overlayInfo.obsDimensions}
        overlayName={overlayInfo.name}
        overlayURL={overlayURL}
      />
    </div>
  );
}
